import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import Card from "../components/ui/Card";
import Button from "../components/ui/Button";

function SuccessPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-app-paper px-4 py-10">
      <div className="mx-auto max-w-xl animate-fade-up">
        <Card className="text-center">
          <p className="ui-kicker">{t("new-ui.success.kicker", { defaultValue: "Success" })}</p>
          <h1 className="ui-title mt-2 text-xl">{t("new-ui.success.title", { defaultValue: "Document flow completed" })}</h1>
          <p className="ui-copy mt-3">
            {t("new-ui.success.description", {
              defaultValue: "Your process ended successfully. You can continue in the new dashboard."
            })}
          </p>
          <div className="mt-5">
            <Link to="/dashboard/35KBoSgoAK">
              <Button>{t("new-ui.success.back-to-dashboard", { defaultValue: "Back to dashboard" })}</Button>
            </Link>
          </div>
        </Card>
      </div>
    </div>
  );
}

export default SuccessPage;
